import { LOCALE } from './locale.ts'

const rules = new Intl.PluralRules(LOCALE)
const numbers = new Intl.NumberFormat(LOCALE)

export type PluralForms = { one: string; other: string } & Partial<Record<`=${number}`, string>>

export function formatCount(count: number): string {
  return numbers.format(count)
}

export function plural(count: number, forms: PluralForms): string {
  const form = forms[`=${count}`] ?? (rules.select(count) === 'one' ? forms.one : forms.other)
  return form.replaceAll('#', numbers.format(count))
}
